export function isPromoSectionEmpty(props) {
    return !props?.title || !props?.description || !props?.image;
}
